import { useContext } from 'react';
import { LayoutEditorContext } from '../../context/LayoutEditorContext/LayoutEditorContext';

export const useLayoutEditorContext = () => {
  const context = useContext(LayoutEditorContext);

  if (context.isProvided === false) {
    throw new Error(
      'useLayoutEditorContext must be used within a LayoutEditorProvider'
    );
  }

  return context;
};
